/**
 * PC端显示 租户
 * @author liuzhiqiang
 */
export default class Tenant {
    /**
     * 租户ID
     */
    public tenantId: string;
    /**
     * 租户的logo
     */
    public logo: string;
    /**
     * 租户名称
     */
    public name: string;
    /**
     * 应用系统名称
     */
    public appName: string;
    /**
     * 显示主题名称
     */
    public theme: string = "default";
    /**
     * 租户的系统域名（不同租户支持三级域名区分,无协议符）
     */
    public domain: string;
    /**
     * 租户的index入口地址（无协议符）
     * 为空表示为独立系统应用租户，无index入口显示
     */
    public tenantIndex: string;
    constructor({ tenantId = '', logo = '', name = '', appName = '', domain = '', tenantIndex = '' }={}) {
        this.tenantId=tenantId;
        this.logo=logo;
        this.name=name;
        this.appName=appName;
        this.domain=domain;
        this.tenantIndex=tenantIndex;
    }
}